var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "dialog",
      staticClass: "dialog-body",
      style: { display: _vm.dialogTableVisible ? "block" : "none" },
      attrs: { title: "君子签用户隐私政策", visible: _vm.dialogTableVisible },
      on: {
        "update:visible": function($event) {
          _vm.dialogTableVisible = $event
        }
      }
    },
    [
      _c("div", { ref: "container", class: ["container"] }, [
        _c("div", { staticClass: "header" }, [
          _c("p", { staticClass: "header-title" }, [
            _vm._v("君子签用户隐私政策")
          ]),
          _c("i", {
            staticClass: "close-icon el-icon-close",
            attrs: { title: "关闭" },
            on: { click: _vm.hideDialog }
          })
        ]),
        _vm._m(0)
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content" }, [
      _c("p", { staticClass: "title" }, [
        _vm._v("\n          用户隐私政策\n        ")
      ]),
      _c("div", { staticClass: "sec" }, [
        _vm._v(
          "\n          欢迎访问重庆易保全网络科技有限公司的电子签名平台（以下简称“平台”），本政策适用于我们提供的产品和服务，包括电子签名产品、存证服务、法律服务等。\n        "
        )
      ]),
      _c("div", { staticClass: "sec" }, [
        _vm._v(
          "\n          我们希望通过本隐私政策向您说明，在使用平台服务时，我们如何收集、使用、存储、分享和转让您的个人信息，以及我们为您提供的访问、更改、删除和保护这些信息的方式。请您在使用平台服务前，务必仔细阅读并了解本隐私政策，在确认充分理解并同意后使用我们的产品或服务。如对本政策内容有任何疑问、意见或建议，您可通过本隐私政策提供的各种联系方式与我们联系。\n        "
        )
      ]),
      _c("div", { staticClass: "pec" }, [
        _vm._v("\n          本政策将帮助您了解以下内容："),
        _c("br"),
        _vm._v("\n          一、我们如何收集您的个人信息；"),
        _c("br"),
        _vm._v("\n          二、我们如何使用您的个人信息；"),
        _c("br"),
        _vm._v("\n          三、我们如何共享、转让、公开您的个人信息；"),
        _c("br"),
        _vm._v("\n          四、我们如何存储您的个人信息；"),
        _c("br"),
        _vm._v("\n          五、我们如何保护您的个人信息；"),
        _c("br"),
        _vm._v("\n          六、您管理个人信息的权利；"),
        _c("br"),
        _vm._v("\n          七、未成年人个人信息保护；"),
        _c("br"),
        _vm._v("\n          八、免责声明；"),
        _c("br"),
        _vm._v("\n          九、如何联系我们；"),
        _c("br"),
        _vm._v("\n          十、隐私政策的变更和修订。"),
        _c("br")
      ]),
      _c("h5", [_vm._v("一、我们如何收集您的个人信息")]),
      _c("div", { staticClass: "sec" }, [
        _vm._v(
          "我们根据合法、正当、必要的原则，收集为实现产品功能所需要的信息，并将收集信息进行合理使用。"
        )
      ]),
      _c("div", { staticClass: "sec" }, [
        _vm._v("我们会收集以下个人或企业信息：")
      ]),
      _c("div", { staticClass: "sec" }, [
        _vm._v("（一）您在注册、开通时提供的信息")
      ]),
      _c("div", { staticClass: "sec" }, [
        _vm._v(
          "\n          为为便于我们提供服务，您在注册或开通服务时需要提供包括真实姓名、个人电话号码、电子邮箱、地址个人身份信息。如您进行身份认证服务，我们还会收集您身份证/护照等身份证明、人脸识别视频、银行卡信息、手机号码、个人手写签名、手持身份证照片及其他您提供的认证信息。收集此类信息是为了满足相关法律法规的实名制要求，若您不提供此类信息，您将无法完成实名认证，亦无法以实名身份签发文件。\n如您是法人单位，我们还会搜集您的公司营业执照信息或组织机构代码证信息、法定代表人姓名及有效证件号码或者身份证正反面照片、公司住所地、公司电话号码及公司对公银行账号信息。"
        )
      ]),
      _c("div", { staticClass: "sec" }, [
        _vm._v("（二）您在使用过程中提供的信息")
      ]),
      _c("div", { staticClass: "sec" }, [
        _vm._v(
          "\n        我们会收集您主动上传至我们的材料，包含合同原文、哈希值或其他书面材料，该文件或材料可能涉及您的隐私信息或商业秘密。我们会对上述信息进行安全保存。除非您主动提交合同审阅的服务，我们不会主动收集或分析这些信息。若您提供的是他人的信息，包括姓名、电话号码、身份证号、收件地址、邮箱地址等个人隐私信息，您需确认获得对方授权且保证对方也知晓并同意受本隐私协议之约束，因您提供的信息造成他人损害的，将由您自行承担责任。同时，如果他人提出相反意见或者向我们明示不愿受本隐私协议约束的，我们将删除相关信息。\n      "
        )
      ]),
      _c("p", { staticClass: "sec" }, [
        _vm._v(
          "此外，为了保障我们服务的连续性及您的账户安全，我们会收集您的下述信息："
        )
      ]),
      _c("div", { staticClass: "sec" }, [
        _vm._v(
          "\n        2.1 设备信息：设备型号、操作系统版本、唯一设备标识符、IP 地址信息。"
        ),
        _c("br"),
        _vm._v(
          "\n        2.2 软件信息：软件的版本号、浏览器类型。为确保操作环境的安全或提供服务所需（调用其他APP用于认证服务），我们会收集有关您使用的移动应用和其他软件的信息。"
        ),
        _c("br"),
        _vm._v(
          "\n2.3 服务日志信息。您在使用我们服务时登录时间、操作内容及时间、服务故障信息等信息。"
        ),
        _c("br"),
        _vm._v(
          "\n2.4 IP及位置信息。例如，我们可能会通过IP地址、GPS、WiFi或基站等途径获取您的地理位置信息。"
        ),
        _c("br"),
        _vm._v(
          "\n2.5如果您使用我们的客服系统，我们将收集您的手机号、邮箱和以及您反馈的信息，用于与您取得联系和解决问题。"
        ),
        _c("br")
      ]),
      _c("div", { staticClass: "sec" }, [_vm._v("（三）其他信息")]),
      _c("div", { staticClass: "sec" }, [
        _vm._v(
          "本隐私协议列明的内容并不能完整罗列并覆盖未来可能实现的所有功能和业务场景，我们将基于本政策未载明的其他特定目的收集您的信息，但会事先征求您的同意。"
        )
      ]),
      _c("div", { staticClass: "sec" }, [_vm._v("（四）征得授权同意的例外")]),
      _c("div", { staticClass: "sec" }, [
        _vm._v(
          "\n        根据相关法律法规规定，以下情形中收集您的个人信息无需征得您的授权同意："
        ),
        _c("br"),
        _vm._v("\n4.1与国家安全、国防安全有关的；"),
        _c("br"),
        _vm._v("\n4.2与公共安全、公共卫生、重大公共利益有关的；"),
        _c("br"),
        _vm._v("\n4.3与犯罪侦查、起诉、审判和判决执行等有关的；"),
        _c("br"),
        _vm._v(
          "\n4.4出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；"
        ),
        _c("br"),
        _vm._v("\n4.5所收集的个人信息是您自行向社会公众公开的；"),
        _c("br"),
        _vm._v(
          "\n4.6从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；"
        ),
        _c("br"),
        _vm._v("\n4.7根据您的要求签订合同所必需的或双方已在合同中另行约定的；"),
        _c("br"),
        _vm._v(
          "\n4.8用于维护所提供的产品或服务的安全稳定运行所必需的，例如处理产品或服务的故障；"
        ),
        _c("br"),
        _vm._v(
          "\n4.9学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；"
        ),
        _c("br"),
        _vm._v("\n4.10法律法规规定的其他情形。"),
        _c("br")
      ]),
      _c("h5", [_vm._v("二、我们如何使用您的个人信息")]),
      _c("div", { staticClass: "sec" }, [
        _vm._v(
          "\n        我们将严格遵守法律法规及与您的约定，将收集到的信息进行如下使用："
        ),
        _c("br"),
        _vm._v("\n（一）帮助您成为我们的用户；"),
        _c("br"),
        _vm._v(
          "\n（二）向您提供产品和服务，包括依托第三方完成的实名认证、意愿认证、存证等服务的合理使用；"
        ),
        _c("br"),
        _vm._v("\n（三）产品开发和服务优化；"),
        _c("br"),
        _vm._v(
          "\n（四）其他用途：当我们要将信息用于本政策未载明的其他用途或要将基于特定目的收集的信息用于其他目的时，会事先征求您的同意。"
        ),
        _c("br"),
        _vm._v(
          "\n您的信息将会存储在平台的服务器上。为了让您有更好的体验、改善我们的服务或经您同意的其他用途，在符合相关法律法规的前提下，我们可能将通过某些服务所收集的信息用于我们的其他服务。例如，将您在使用我们某项服务时的信息，用于用户研究分析与统计等服务，但我们不会将我们存储在分析软件中的信息与您在应用程序中提供的个人身份信息相结合。\n      "
        )
      ]),
      _c("h5", [_vm._v("三、 我们如何共享、转让、公开披露您的个人信息")]),
      _c("div", { staticClass: "sec" }, [
        _vm._v(
          "我们不会与任何公司、组织和个人共享您的个人信息，但以下情况除外："
        )
      ]),
      _c("div", { staticClass: "sec" }, [
        _vm._v("\n        （一）共享"),
        _c("br"),
        _vm._v(
          "\n1.1我们可能会根据法律法规规定、诉讼争议解决需要，或按行政、司法机关依法提出的要求，对外共享您的个人信息。"
        ),
        _c("br"),
        _vm._v(
          "\n1.2与合作机构共享: 为实现本电子签署或服务目的，我们的某些服务将由我们和合作机构共同提供。我们会根据法律法规与合作伙伴共享您的某些个人信息。您的个人身份信息及签署信息需传输至电子认证服务机构(简称CA)、公证处、区块链、互联网法院、仲裁委、第三方身份认证机构，由上述权威机构出具相应证明文件或处理案件等目的使用并保存。我们仅会出于合法、正当、必要的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。\n"
        ),
        _c("br"),
        _vm._v(
          "1.3为了让您有更好的体验、改善我们的服务或经您同意的其他用途，在符合相关法律法规的前提下，我们可能将通过某些服务所收集的信息用于我们的其他服务。例如，将您在使用我们某项服务时的信息，用于用户研究分析与统计等服务。\n"
        ),
        _c("br"),
        _vm._v(
          "1.4为了确保服务的安全，帮助我们更好地了解我们应用程序的运行情况，我们可能记录相关信息或将所收集到的信息用于大数据分析，例如，您应用程序的频率、故障信息、总体使用情况、性能数据或分析形成不包含任何个人信息的城市热力图或行业洞察报告等。我们可能对外公开并与我们的合作伙伴分享经统计加工后不含身份识别内容的信息，用于了解用户如何使用我们服务或让公众了解我们服务的总体使用趋势。\n"
        ),
        _c("br"),
        _vm._v("（二）转让\n"),
        _c("br"),
        _vm._v(
          "我们不会将您的个人信息转让给其他任何公司、组织和个人，但以下情形除外：在获得您明确同意的情形下转让，我们会向其他方转让我们已经获取的您的个人信息。\n"
        ),
        _c("br"),
        _vm._v("（三）披露\n"),
        _c("br"),
        _vm._v("我们仅会在以下情况下，公开披露您的个人信息：\n"),
        _c("br"),
        _vm._v("3.1已经获得您明确同意。\n"),
        _c("br"),
        _vm._v(
          "3.2在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。\n"
        ),
        _c("br"),
        _vm._v("3.3法律法规规定的其他情形。\n      ")
      ]),
      _c("h5", [_vm._v("四、 我们如何存储您的个人信息")]),
      _c("div", { staticClass: "sec" }, [
        _vm._v(
          "\n        （一）我们在中华人民共和国境内收集和产生的个人信息将存储在中华人民共和国境内。若为处理跨境业务，确需向境外机构传输境内收集的相关个人信息的，我们会按照法律、行政法规和相关监管部门的规定执行。我们会确保您的个人信息得到足够的保护，例如匿名化、安全存储等。\n"
        ),
        _c("br"),
        _vm._v(
          "（二）我们仅在本政策所属目的所必须期间和法律法规要求的时限内存储您的个人信息，根据《电子签名法》规定，我们会保存您的个人信息五年。\n"
        ),
        _c("br"),
        _vm._v(
          "（三）但在下列情况下，我们有可能因需符合法律要求，更改个人信息的存储时间：\n"
        ),
        _c("br"),
        _vm._v("3.1 为遵守适用的法律法规等有关规定；\n"),
        _c("br"),
        _vm._v("3.2 为遵守法院判决、裁定或其他法律程序的规定；\n"),
        _c("br"),
        _vm._v("3.3 为遵守相关政府机关或法定授权组织的要求；\n"),
        _c("br"),
        _vm._v("3.4 我们有理由确信需要遵守法律法规等有关规定；\n"),
        _c("br"),
        _vm._v(
          "3.5 为执行相关服务协议或本政策、维护社会公共利益，为保护我们的客户、我们或我们的关联公司、其他用户或雇员的人身财产安全或其他合法权益所合理必需的用途。\n"
        ),
        _c("br"),
        _vm._v(
          "（四）如我们停止运营平台的产品或服务，我们将及时停止继续收集您个人信息的活动，并对我们存储的个人信息进行删除或匿名化处理。\n      "
        )
      ]),
      _c("h5", [_vm._v("五、 我们如何保护您的个人信息")]),
      _c("div", { staticClass: "sec" }, [
        _vm._v(
          "\n        （一）对我们与之共享个人信息的公司、组织和个人，我们会与其签署严格的数据保护条款，要求其按照我们的说明、本隐私政策以及其他任何相关的保密和安全措施来处理个人信息。\n"
        ),
        _c("br"),
        _vm._v(
          "（二）为了保障您的信息安全，我们在收集您的信息后，将采取各种隔离必要的措施保护您的信息。我们会将去标识化后的信息与可用于恢复识别个人的信息分开存储，确保在针对去标识化信息的后续处理中不重新识别个人。\n"
        ),
        _c("br"),
        _vm._v(
          "（三）我们承诺我们将使信息安全保护达到业界领先的安全水平。为保障您的信息安全，我们致力于使用各种安全技术及配套的管理体系来尽量降低您的信息被泄露、毁损、误用、非授权访问、非授权披露和更改的风险。例如：通过网络安全软件进行安全传输、信息安全存储、严格限制数据中心的访问。传输和存储个人敏感信息（含个人生物识别信息）时，我们将采用安全、权限控制、去标识化等安全措施。同时我们对数据采取了备份和恢复技术，在数据丢失的情况下及时恢复。\n"
        ),
        _c("br"),
        _vm._v(
          "（四）在不幸发生用户信息安全事件（泄露、丢失等）后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知用户信息主体时，我们会采取合理、有效的方式发布公告。\n      "
        )
      ]),
      _c("h5", [_vm._v("六、 您管理个人信息的权利")]),
      _c("div", { staticClass: "sec" }, [
        _vm._v("\n        （一）访问您的个人信息\n"),
        _c("br"),
        _vm._v(
          "您可以通过访问 www.junziqian.com 来查询、编辑您账号中的个人资料信息和支付信息、更改您的密码、添加安全信息。\n"
        ),
        _c("br"),
        _vm._v("（二）删除您的个人信息\n"),
        _c("br"),
        _vm._v("您可以通过拨打客服电话400-808-9187来申请删除您的个人信息\n"),
        _c("br"),
        _vm._v("在以下情况发生时，您有权要求平台删除您的个人信息：\n"),
        _c("br"),
        _vm._v("2.1我们没有征求您的明确同意，收集了您的个人信息。\n"),
        _c("br"),
        _vm._v("2.2我们处理您的个人信息违反了法律法规要求。\n"),
        _c("br"),
        _vm._v("2.3我们违反了与您的约定来使用和处理您的个人信息。\n"),
        _c("br"),
        _vm._v("2.4您不再使用或注销了平台账号。\n"),
        _c("br"),
        _vm._v("2.5我们停止对您提供服务。\n"),
        _c("br"),
        _vm._v(
          "基于业务的需要，为维护交易多方的利益，在本条第二款2.4的情形下，我们仍将保留您与实名认证、意愿认证、签署业务直接关联的个人信息。\n"
        ),
        _c("br"),
        _vm._v(
          "如您仍想删除此部分信息，需您与业务全部相关方授权同意，我们在收到您与业务全部相关方共同的删除指令后，会将该业务涉及的您的个人信息进行删除。\n"
        ),
        _c("br"),
        _vm._v(
          "当您或我们协助您删除相关信息后，因为适用的法律和安全技术，我们可能无法立即从备份系统中删除相应的信息，我们将安全地存储您的个人信息并避免任何进一步处理，直到备份可以清除或实现匿名。\n"
        ),
        _c("br"),
        _vm._v("（三）更正您的个人信息\n"),
        _c("br"),
        _vm._v(
          "当您发现收集、存储的其个人信息有错误或需要更新时，可通过www.junziqian.com或联系客服予以更正。\n      "
        )
      ]),
      _c("h5", [_vm._v("七、 未成年人个人信息保护")]),
      _c("div", { staticClass: "sec" }, [
        _vm._v(
          "\n        若您是未满18周岁的未成年人，在使用我们的产品及相关服务前，应在您的父母或其他监护人监护、指导下共同阅读并同意本隐私政策；\n"
        ),
        _c("br"),
        _vm._v(
          "我们根据国家相关法律法规的规定保护未成年人的个人信息，只会在法律允许、父母或其他监护人明确同意或保护未成年人所必要的情况下收集、使用、共享或披露未成年人的个人信息；如果我们发现在未事先获得可证实的父母或其他监护人同意的情况下收集了未成年人的个人信息，则会设法尽快删除相关信息。\n"
        ),
        _c("br"),
        _vm._v(
          "若您是未成年人的监护人，当您对您所监护的未成年人的个人信息有相关疑问时，请通过本隐私政策公示的联系方式与我们联系。\n      "
        )
      ]),
      _c("h5", [_vm._v("八、 免责声明")]),
      _c("div", { staticClass: "sec" }, [
        _vm._v(
          "\n        （一）平台含有其他网站的链接，我们可能在任何需要的时候增加商业伙伴或共用品牌的网站。平台对您通过平台链接到其他网站需要的隐私保护不负任何责任。\n"
        ),
        _c("br"),
        _vm._v(
          "（二）因您个人原因导致账号密码泄露从而导致个人信息泄露的，平台不负任何责任，但我们会积极地配合您找回密码或更改密码。\n      "
        )
      ]),
      _c("h5", [_vm._v("九、 如何联系我们")]),
      _c("div", { staticClass: "sec" }, [
        _vm._v(
          "\n        如果您对我们的隐私政策及对您个人信息的处理有任何疑问、意见、建议或投诉，可通过客服电话400-808-9187来反馈，我们提供7*24小时的热线服务。\n      "
        )
      ]),
      _c("h5", [_vm._v("十、 隐私政策的变更和修订")]),
      _c("div", { staticClass: "sec" }, [
        _vm._v(
          "\n        我们可能适时修订本政策内容。如该等变更会导致您在本政策项下权利的实质减损，我们将在变更生效前，通过在页面显著位置提示、向您发送电子邮件等方式通知您。在该种情况下，若您继续使用我们的服务，即表示同意受经修订的政策约束。\n      "
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5d4016e2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d4016e2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/auth/APIAuth/components/protocol/Privacy.vue
// module id = C1G8
// module chunks = 88 254